/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const strings = {
  title: 'Login',

  appTitle: 'Rawam',

  username: 'Username',
  email: 'Email',
  password: 'Password',
  rememberMe: 'Remember me next time.',
  forgotPassword: 'Forgot Password?',
  userManual: 'User Manual',
  newUser: 'Don\'t have an account? register now',
  selectLogin: 'Select Login',
  otp: 'One time password',
  resendOtp: 'Re-send password',
  backToLogin: 'Login',
  sendLoginLink: 'Send login link',

  submitting: 'Please wait...',

  waitScreen: 'Please wait...',

  close: 'Close',

  resetPassword: 'Reset Password',
  newPassword: 'Password',
  confirmPassword: 'Confirm Password',

  localAccount: 'Local Rawam account',
  administratorAccess: 'Administrator access',
  administratorAccessHint: 'Only system administrators with local accounts can use this sign in.',
  localAccess: 'Local account access',
  localAccessHint: 'Use your local account. Your Microsoft account does not work in this form.',
  returnToMicrosoft: 'Back to Microsoft sign in',
  returnToMagicLink: 'Back to email link sign in',
  retryLoginConfig: 'Try again',
  localAccountHint: 'For local accounts and administrators. For your work account, use the Microsoft button below.',
  signInMicrosoft: 'Sign in with Microsoft',
  or: 'or',

  messages: {
    invalidLoginLink: 'This sign-in link is invalid or expired. Please request a new link.',
    entraFailed: 'Microsoft Entra sign-in could not be completed. Please try again or contact your administrator.',
    required: 'Field required',
    invalidEmail: 'Please enter a valid email address',
    loginLinkSent: 'A login link has been sent to your email. Please check your inbox or spam folder.',
    passwordMismatch: 'The Password and Confirmation Password must match.',

    usernameRequired: 'Please type the username',

    logonFailure: 'Invalid Credentials',

    lockedOut: 'Your account is locked',

    disabled: 'Your account is disabled',

    checkInput: 'Please check your input!',

    resetLinkSent:
      'We have sent an email to you contains the link for resetting your password',

    userNotFound: 'Username not found',

    newOtp:
      'A new OTP has been generated and sent to the registered email, please use it to verifiy the login',

    activeOtp:
      'The last OTP is still active, please use the last sent OTP',

    wrongOtp: 'Wrong Otp, Please try Again!',

    otpMismatch: 'The entered OTP does not match the sent one, please try again',

    otpExpired: 'This OTP is no longer valid and has expired please click re-send botton to send new OTP',

    systemError: 'A system error occurred, please try again',
  },

  logoAlt: 'Rawam',
}
